<li class="col-span-1 flex flex-row gap-x-2 py-1.5 px-2 border border-white/5 rounded-lg dark:bg-white/5 bg-gray-200">

    <div class="shrink-0 flex flex-col p-1">
        @if (question.type === 'do') {
        <span class="inline-flex items-center rounded-md bg-green-400/10 px-2 py-1 text-xs font-medium text-green-400 inset-ring inset-ring-green-500/20">Do</span>
        } @else {
        <span class="inline-flex items-center rounded-md bg-red-400/10 px-2 py-1 text-xs font-medium text-red-400 inset-ring inset-ring-red-400/20">Don't</span>
        }


    </div>
    <div class="flex-1 flex flex-row px-2 py-1">
        <p class="text-sm text-primary">{{ question.statement }}</p>
    </div>
</li>